module.exports = __webpack_public_path__ + "img/LanghamLogo.17890704.png";